import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=10717404&scoped=true"
import script from "./Managers.vue?vue&type=script&lang=js"
export * from "./Managers.vue?vue&type=script&lang=js"
import style0 from "./Managers.vue?vue&type=style&index=0&id=10717404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10717404",
  null
  
)

export default component.exports